import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import DefaultLayoutV3 from './DefaultLayoutV3';

interface IDashboardLayoutProps {
  children?: ReactNode;
}

// The dashboard alert rows cap at max-w-6xl and add their own px-5 inside
// Body's, so the banner has to match to line up with them. -mb-3 trims Body's
// py-8 down to the 20px the alerts space themselves by.
const DASHBOARD_BANNER_CLASSES =
  '-mb-3 px-5 pt-5 md:px-10 xl:mx-auto xl:max-w-6xl xl:px-5';

const DashboardLayout = ({ children }: IDashboardLayoutProps): JSX.Element => {
  return (
    <DefaultLayoutV3
      bannerClassName={DASHBOARD_BANNER_CLASSES}
      mainWrapperBgColor="white"
    >
      <DefaultLayoutV3.Body>{children ?? <Outlet />}</DefaultLayoutV3.Body>
    </DefaultLayoutV3>
  );
};

export default DashboardLayout;
